/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'

import {SidebarMenuItem} from './SidebarMenuItem'
import {getAuth} from '../../../../../app/modules/auth'
import {getUserById} from '../../../../../app/modules/apps/user-management/users-list/core/_requests'

const usuarioLocalStorage = getAuth()
//ejemplo

const SidebarMenuMain = () => {
  const usuario = getUserById(usuarioLocalStorage?.usuarioGc_Track?.id)
  const [rolActual, setRolActual] = useState<string | null | undefined>('')

  useEffect(() => {
    if (usuario) {
      usuario
        .then((resultado) => {
          setRolActual(resultado?.Rol?.rol)
        })
        .catch((error) => {
          console.error('Error al obtener el usuario:', error)
        })
    }
  }, [usuario])
  const intl = useIntl()
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-4 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Principal</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/crafted/mi-perfil/settings'
        icon='profile-circle'
        title='Mi perfil'
        fontIcon='bi-layers'
      />
      {/* {rolActual === 'super' && (
        <>
          <SidebarMenuItem to='/dashboard' icon='element-11' title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} fontIcon='bi-app-indicator' />
        </>
      )} */}
      {/* <SidebarMenuItem to='/crafted/account/settings' icon='switch' title='Activación / Desactivación' fontIcon='bi-layers' /> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Ordenes</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/apps/ordenes-management/'
        title='Ordenes'
        fontIcon='bi-person'
        icon='lots-shopping'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Paneles</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/apps/panel-management/paneles'
        title='Paneles'
        fontIcon='bi-person'
        icon='devices'
      />

      {rolActual === 'Distribuidor' && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                Configuraciones
              </span>
            </div>
          </div>
          {/* <SidebarMenuItem to='/crafted/pages' title='Enlaces' fontIcon='bi-person' icon='disconnect' /> */}

          <SidebarMenuItem
            to='/apps/user-management/users'
            title='Usuarios Store'
            fontIcon='bi-person'
            icon='people'
          />
          <SidebarMenuItem
            to='/apps/company-management/companias'
            title='Empresas'
            fontIcon='bi-person'
            icon='bank'
          />
          <SidebarMenuItem
            to='/apps/productos-management/productos'
            title='Producto'
            fontIcon='bi-person'
            icon='bank'
          />
          <SidebarMenuItem
            to='/apps/promociones-management/users'
            title='Promociones'
            fontIcon='bi-person'
            icon='discount'
          />
          <SidebarMenuItem
            to='/apps/logs-management/logs'
            title='Eventos del Sistema'
            fontIcon='bi-person'
            icon='information-5'
          />
          <SidebarMenuItem
            to='/apps/userGCTrack-management/users'
            title='Usuarios App'
            fontIcon='bi-person'
            icon='people'
          />
        </>
      )}
    </>
  )
}

export {SidebarMenuMain}
